export enum NavigationBarTypeEnum {
  Default = 'navigation-bar',
  Extended = 'navigation-bar-extended'

}
